import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
    PERMISSION_ARTICLES_WRITE
  } from '../../constants'
import WithAjax from '../common/helpers/WithAjax'
import {setJumbotronTitle} from '../../actions/common'
import {checkPermission} from '../common/functions/permissions'
import Table from '../../tables/reactable/DefaultTable'
import ProtectedElement from '../common/helpers/ProtectedElement'

class UserList extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onFilter = this.onFilter.bind(this)
    this.state = {
      items: [],
      itemsPerPage: 10,
      openBtnVisible: checkPermission(PERMISSION_ARTICLES_WRITE),
      openBtnLabel: 'Edit',
      search: '',
      filter: {
        Status: 'active'
      }
    }
    this.columns = [
      'FullName',
      'UserPrincipalName',
      'LastLoginDate'
    ]
    this.columnNames = [
      'Full name',
      'User name',
      'Last login date'
    ]

    this.handleAdd = this.handleAdd.bind(this);
  }

  componentDidMount() {
    let url = 'adminusers '

    this.props.setJumbotronTitle('Users');

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        return data[index].NavigationParam = data[index].Id;
      });

      this.setState({
        items: Array.from(data)
      })
    })
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  handleAdd(event) {
    event.preventDefault();
    this.props.history.push('/users/add');
  }

  onSearch(e) {
    e.preventDefault()
    this.setState({
      search: e.target.value
    })
    return false
  }

  onFilter(filter){
    this.setState({
      filter: filter
    })
  }

  render() {
    let items = this.state.items.map(item => {
      return Object.assign({}, item, {
      	LastLoginDate: (<span lastlogindate={item.LastLoginDate}>{item.LastLoginDateFormatted}</span>),
      })
    });

    let addBtn = (
      <div className="row">
        <div className="col-md-12 text-right pb-3">
          <ProtectedElement permission={PERMISSION_ARTICLES_WRITE}>
            <button className="btn btn-rounded btn-primary" onClick={this.handleAdd}>
            Add
            </button>
          </ProtectedElement>
        </div>
      </div>
    )

    return (
      <div>
        {addBtn}
        <Table
          items={items}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          searchable={['FullName', 'UserPrincipalName', 'LastLoginDate']}
          search={this.state.search}
          onSearch={this.onSearch}
          filterable={[{
            column: 'Status',
            filters: [
              {
                value: 'active',
                label: 'Active'
              },
              {
                value: 'inactive',
                label: 'Inactive'
              }
            ]
          }]}
          filter={this.state.filter}
          onFilter={this.onFilter}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={this.state.openBtnVisible}
          openBtnLabel={this.state.openBtnLabel}
          openBtnHref="/users/{NavigationParam}/edit"
          sortable={[
            'FullName',
            'UserPrincipalName',
            {
              column: 'LastLoginDate',
              sortFunction: function(a, b) {
                return a.props ? a.props.lastlogindate.localeCompare(b.props.lastlogindate): 0;
              }
            }
          ]}
          defaultSort={{column: 'LastLoginDate', direction: 'desc'}}
        />
        {addBtn}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
})
const mapDispatchToProps = dispatch => ({
  setJumbotronTitle(title) { dispatch(setJumbotronTitle(title)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(UserList))
